import { INumericIdentifierModel, ITeamUpload, IUpdatedAtAndBy, } from "@api/schema"
import { ILockableModel } from "@redux/usecases/lock/schema-definitions"

import { DocumentTemplateCategory } from "./templates"

// #region API definitions

/**
 * Module-Interface to avoid using specific Interface like IProject for owner property in interface IDocument.
 * @see https://futureprojects.atlassian.net/browse/FCP-1965
 */
export interface IDocumentOwner extends INumericIdentifierModel, ILockableModel {
  // TODO: refactor @type into IModel, @see FCP-1798
  "@type"?: string
}

/**
 * Structure of a Document
 */
export interface IDocument<Owner extends IDocumentOwner = IDocumentOwner> extends INumericIdentifierModel, IUpdatedAtAndBy {
  /**
   * Backend set type of the IDocument, e.g. App\Entity\Document
   */
  "@type"?: string
  /**
   * Category of the document (type of a Document), e.g. "businessplan", "other".
   */
  category?: DocumentCategory
  /**
   * This the entity the document belongs to.
   */
  owner?: Owner
  /**
   * Name of the type of the used template.
   *
   * NOTE: the backend does not validate the template types, because it does not know them.
   * So they are simple strings, coming from the backend, should be validated as DocumentTemplateCategory
   * in the client.
   */
  template?: DocumentTemplateCategory
  /**
   * Title of the document.
   */
  title?: string
  /**
   * Description of the document. Not printed to the PDF, for team usage only.
   */
  description?: string
  /**
   * Is this document the "primary" of its type?
   * E.g. necessary to decide, which document is served to an ExternalProvider, e.g. SINN,
   * when a document of type "businessplan" is requested.
   */
  isPrimary?: boolean
  /**
   * Last PDF file created from that document.
   */
  pdfFile?: ITeamUpload
  /**
   * Attachments of a document are added in Version 2.
   */
  // attachments?: any[] // TODO: t.b.d.
}


// #region document categories

/**
 * Known document categories.
 *
 * DO NOT CHANGE existing category names, as they are stored in the database to recognize the category of documents.
 * Changing the name means, that Document types may not longer be recognized.
 */
export enum DocumentCategory {
  /**
   * Businessplan document categories.
   */
  Businessplan = "businessPlan",
  Canvas = "canvas",
  /**
   * Document category that does not match any other category.
   */
  Other = "other",
}

// #endregion

// #endregion API definitions
